import { axiosInstance } from '@meterup/common';
import { graphqlClient as gqlClient } from '@meterup/graphql';

export const axiosInstanceJSON = axiosInstance;

export const graphqlClient = gqlClient;
